import { WalkingIcon, TransitIcon, CarIcon } from '@/assets/icons'
import React from 'react'
import { EVENT_DOT_ANCHOR } from '../Column/Column.styles'
import { RailConnector } from '../timelineRail.styles'
import {
	TravelSegmentContainer,
	TravelDotColumn,
	TRAVEL_CHIP_ANCHOR,
	IconWrapper,
	SegmentContent,
	InfoContainer,
	Bullet,
	DirectionsText,
} from './TravelSegment.styles'
import { formatSegmentDistance, formatSegmentDuration, pickSegmentRoute } from './segmentDisplay'
import { TravelSegmentProps } from './types'

const TravelSegment: React.FC<TravelSegmentProps> = ({ segment, isHidden = false }) => {
	const route = pickSegmentRoute(segment)

	if (!route) return null

	const { durationSeconds, distanceMeters, transportMode, originPlaceId, destinationPlaceId } = route

	const handleClick = () => {
		const travelMode = transportMode.toLowerCase()
		const webURLString = `https://www.google.com/maps/dir/?api=1&origin=${originPlaceId}&origin_place_id=${originPlaceId}&destination=${destinationPlaceId}&destination_place_id=${destinationPlaceId}&travelmode=${travelMode}`
		window.open(webURLString, '_blank', 'noopener,noreferrer')
	}

	const getIcon = () => {
		switch (transportMode) {
			case 'TRANSIT':
				return <TransitIcon />
			case 'WALKING':
				return <WalkingIcon />
			default:
				return <CarIcon />
		}
	}

	return (
		<TravelSegmentContainer $isHidden={isHidden}>
			<TravelDotColumn>
				{/* A segment always sits between two events: one dash run from the
				    chip's centre into the next event's dot. The incoming line is
				    drawn by the previous event row. */}
				<RailConnector $from={TRAVEL_CHIP_ANCHOR} $into={EVENT_DOT_ANCHOR} />
				<IconWrapper>{getIcon()}</IconWrapper>
			</TravelDotColumn>
			<SegmentContent onClick={handleClick}>
				<InfoContainer>
					{durationSeconds === null && distanceMeters === null ? (
						<span>ETA N/A</span>
					) : (
						<>
							<span>{formatSegmentDuration(durationSeconds)}</span>
							<Bullet>·</Bullet>
							<span>{formatSegmentDistance(distanceMeters)}</span>
						</>
					)}
				</InfoContainer>
				<DirectionsText>Directions →</DirectionsText>
			</SegmentContent>
		</TravelSegmentContainer>
	)
}

export default TravelSegment
